import React from "react";
import "./styles.scss";

interface Props {
  className?: string;
}

export const GearLoader = (props: Props) => {
  return (
    <div className={`loader-gear-wrapper ${props.className || ""}`}>
      <div className="loader-gear">
        <div>
          <div />
          <div />
          <div />
          <div />
          <div />
          <div />
        </div>
      </div>
    </div>
  );
};
